<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div> 
      </div>

      <div class="modal__main-icon modal__main-icon--setting"></div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="form">
        <div class="navigators">
          <div class="navigator navigator--active">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">{{ $t(`addRoleModal.${"title"}`) }}</div>
          </div>
        </div>
        <div class="add__form">
          <transition name="fade" mode="out-in">
            <div class="add__content">
              <div class="form__field">
                <div class="user__select">
                  <VSelect class="select select--default" :options="roleCreateTeams" :reduce="(team) => team.id" label="name"
                   :placeholder="$t(`addRoleModal.${'selectTeam'}`)" :class="{ 'input--error': selectedTeamHasError }"
                    v-model="selectedTeam" />
                </div>
                <div class="form__error" v-if="selectedTeamHasError">
                  {{ $t(`addRoleModal.${"teamErrorMsg"}`) }}
                </div>
              </div>
              <div class="form__field role-name-field">
                <input type="text" class="input input--default" :class="{ 'input--error': roleNameHasError }"
                  :placeholder="$t(`addRoleModal.${'rolePlaceholder'}`)" v-model="roleName" />
                <div class="form__error" v-if="roleNameHasError">
                  {{ $t(`addRoleModal.${"roleErrorMsg"}`) }}
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading"></div>
      <div v-else>
        <button v-if="canCreateRole"
          class="modal__button modal__button--submit button button--default" @click="addRole()">
          <span>{{ $t(`addRoleModal.${"addRoleBtn"}`) }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
 
defineOptions({
  name: "AddRoleModal"
});

const store = useStore();
const route = useRoute();
 
const roleName = ref("");
const roleNameHasError = ref(false);
const isRequesting = ref(false);
const selectedTeam = ref("");
const selectedTeamHasError = ref(false);
 
const teams = computed(() => store.getters.teams);
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const roleCreateTeams = computed(() => {
  const authorizedIds = store.getters.authorizedTeamIds("role_create");
  if (authorizedIds === null && isSuperAdmin.value) return teams.value || [];
  return store.getters.authorizationMemberships
    .filter((membership) => authorizedIds.includes(membership.team.id))
    .map((membership) => membership.team);
});
const canCreateRole = computed(() => {
  if (isSuperAdmin.value) return true;
  return store.getters.hasTeamPermission("role_create", selectedTeam.value);
});
 
watch(roleName, (newValue) => {
  roleNameHasError.value = !newValue;
});

watch(selectedTeam, (newValue) => {
  selectedTeamHasError.value = !newValue;
});
 
const closeModal = () => {
  store.commit("setShowAddRoleModal", false);
};

const getTeams = async () => {
  await store.dispatch("getTeams");
};

const addRole = async () => {
  isRequesting.value = true;
  try {
    if (roleName.value && selectedTeam.value && canCreateRole.value) {
      await store.dispatch("createRole", {
        title: roleName.value,
        team_id: selectedTeam.value
      });

      await store.dispatch("getRolesByTeam", selectedTeam.value);
      closeModal();
    } else {
      if (roleName.value === "" || roleName.value === null) {
        roleNameHasError.value = true;
      }
      if (selectedTeam.value === "" || selectedTeam.value === null) {
        selectedTeamHasError.value = true;
      }
    }
  } finally {
    isRequesting.value = false;
  }
};
 
onMounted(async () => {
  if (store.getters.loggedUser?.is_super_admin === true && !teams.value.length) {
    await getTeams();
  }
  const routeTeamId = Number(route.query.team_id);
  const initialTeam = roleCreateTeams.value.find((team) => team.id === routeTeamId)
    || roleCreateTeams.value.find((team) => team.id === store.getters.currentTeamId)
    || roleCreateTeams.value[0];
  if (!initialTeam) {
    closeModal();
    return;
  }
  selectedTeam.value = initialTeam.id;
});
</script>

<style scoped lang="scss">
.form__field {
  margin-top: 80px;
}

.modal__button {
  left: 50%;
  transform: translateX(-50%);
  bottom: 200px;
}

.role-name-field {
  margin-top: 30px;
}
</style>
